





























































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { MessageService } from "@/shared/services/message-service";
import scheduled_tasksModule from "@/store/modules/scheduled_tasks-module";
import { scheduled_task } from "@/shared/dtos/logs/scheduled_task";

@Component({
  name: "ScheduledTasksViewer",
})
export default class ScheduledTasksViewer extends Vue {
  public loading: boolean = false;
  public saving: boolean = false;
  public pollingActive: boolean = true;
  private pollInterval: any = null;

  public errorDialog: boolean = false;
  public editDialog: boolean = false;
  public selectedTask: scheduled_task | null = null;
  public editForm: any = null;

  public runningTasks: string[] = [];

  public headers = [
    { text: "Tarea / Descripción", value: "name", width: "250px" },
    {
      text: "Activa",
      value: "enabled",
      width: "100px",
      align: "center",
      sortable: false,
    },
    {
      text: "Intervalo",
      value: "interval_seconds",
      width: "100px",
      align: "right",
    },
    { text: "Ejecs.", value: "run_count", width: "80px", align: "right" },
    {
      text: "Últ. Duración",
      value: "duration",
      width: "110px",
      align: "right",
    },
    {
      text: "Estado",
      value: "is_running",
      width: "130px",
      align: "center",
      sortable: false,
    },
    {
      text: "Resultado",
      value: "last_success",
      width: "110px",
      align: "center",
    },
    { text: "Próxima Ejecución", value: "next_run_utc", width: "180px" },
    {
      text: "Acciones",
      value: "actions",
      width: "140px",
      align: "center",
      sortable: false,
    },
  ];

  public get tasks(): scheduled_task[] {
    return scheduled_tasksModule.tasks;
  }

  public mounted() {
    this.fetchTasks();
    this.startPolling();
  }

  public beforeDestroy() {
    this.stopPolling();
  }

  private startPolling() {
    this.stopPolling();
    this.pollInterval = setInterval(() => {
      if (this.pollingActive && !this.loading) {
        this.fetchTasks();
      }
    }, 10000);
  }

  private stopPolling() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
      this.pollInterval = null;
    }
  }

  public async fetchTasks() {
    this.loading = true;
    try {
      await scheduled_tasksModule.getScheduledTasks();
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false;
    }
  }

  public async runNow(task: scheduled_task) {
    if (this.runningTasks.includes(task.name)) return;

    this.runningTasks.push(task.name);
    try {
      await scheduled_tasksModule.runTaskNow(task.name);
      MessageService.toast(
        `Se ha enviado la señal de ejecución a ${task.name}`
      );
    } catch (e) {
      MessageService.alert(
        "Error",
        "No se pudo forzar la ejecución",
        MessageService.TypeError
      );
    } finally {
      this.runningTasks = this.runningTasks.filter((n) => n !== task.name);
    }
  }

  public async toggleEnabled(task: scheduled_task) {
    try {
      // Nota: El v-switch ya actualizó task.enabled localmente
      await scheduled_tasksModule.updateScheduledTask({
        name: task.name,
        enabled: task.enabled,
      });
      MessageService.toast(
        `Tarea ${task.name} ${task.enabled ? "habilitada" : "deshabilitada"}`
      );
    } catch (e) {
      // Revertir en caso de fallo
      task.enabled = !task.enabled;
      MessageService.alert(
        "Error",
        "No se pudo actualizar el estado",
        MessageService.TypeError
      );
    }
  }

  public openEdit(task: scheduled_task) {
    this.editForm = {
      name: task.name,
      enabled: task.enabled,
      interval_seconds: task.interval_seconds,
    };
    this.editDialog = true;
  }

  public async saveConfig() {
    this.saving = true;
    try {
      await scheduled_tasksModule.updateScheduledTask(this.editForm);
      MessageService.toast("Configuración guardada correctamente");
      this.editDialog = false;
    } catch (e) {
      MessageService.alert(
        "Error",
        "No se pudo guardar la configuración",
        MessageService.TypeError
      );
    } finally {
      this.saving = false;
    }
  }

  public showError(task: scheduled_task) {
    this.selectedTask = task;
    this.errorDialog = true;
  }

  public formatRelative(dateStr: string) {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const now = new Date();
    const diff = date.getTime() - now.getTime();
    const mins = Math.floor(diff / 60000);

    if (mins < 0) return "Pendiente...";
    if (mins < 60) return `En ${mins} min`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `En ${hours} h`;
    return (
      date.toLocaleDateString() + " " + date.toLocaleTimeString().substr(0, 5)
    );
  }

  // -------- DIAGNÓSTICOS --------

  public isTaskStuck(task: scheduled_task): boolean {
    if (!task.is_running || !task.last_start_utc) return false;
    const start = new Date(task.last_start_utc).getTime();
    const now = new Date().getTime();
    const hours = (now - start) / (1000 * 60 * 60);
    return hours > 1;
  }

  public isSystematicFailure(task: scheduled_task): boolean {
    return task.last_success === false && task.run_count > 3;
  }

  public calculateDuration(task: scheduled_task): string {
    if (!task.last_start_utc || !task.last_end_utc) return "---";
    const start = new Date(task.last_start_utc).getTime();
    const end = new Date(task.last_end_utc).getTime();
    const diff = end - start;
    if (diff < 0) return "---";

    const secs = Math.floor(diff / 1000);
    if (secs < 60) return `${secs}s`;
    const mins = Math.floor(secs / 60);
    return `${mins}m ${secs % 60}s`;
  }
}
